import script from "./ProsemirrorEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProsemirrorEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ProsemirrorEditor.vue?vue&type=style&index=0&id=6afe9d26&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afe9d26"]])

export default __exports__